/* This example requires Tailwind CSS v2.0+ */
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Home } from "../../components/backgrounds/Home";

function Link() {
  return <a href="/tarifas">Tasas y Tarifas vigentes</a>;
}

const faqs = [
  {
    question:
      "1. ¿Cuáles son los requisitos para acceder a un crédito en Galilea?",
    answer:
      "Los requisitos para poder acceder son 4;  Ser mayor de edad, vivir en Colombia, tener una cuenta bancaria a tu nombre y tener un número de celular y correo electrónico propios y activos.",
  },
  {
    question:
      "2. ¿Cuáles son los intereses y costos opcionales asociados al crédito que ofrece Galilea?",
    answer: `Puedes consultar las tasas y tarifas vigentes en el siguiente enlace:`,
    href: "/tarifas",
  },
  {
    question:
      "3. ¿Cuáles son los tiempos de desembolso del crédito con Galilea?",
    answer:
      "El tiempo máximo en el que deberías recibir el desembolso a tu cuenta es de 1 día hábil como máximo, en caso de no recibirlo dentro del plazo contáctate por alguno de nuestros canales de atención.",
  },
  {
    question: "4. ¿Cómo puedo ejercer el derecho de retracto o desistimiento?",
    answer:
      "El Usuario podrá en ejercicio de su derecho al retracto solicitar el desistimiento del crédito requerido, dentro de los cinco (5) días, contados a partir de la aprobación del crédito. El Usuario deberá realizar la devolución del capital desembolsado en las mismas condiciones dentro del tiempo indicado anteriormente.",
    answer2:
      "Así mismo, el Usuario deberá asumir el costo opcional de Firma Electrónica, si este fue adquirido por él, en virtud que es un servicio independiente al crédito y de acuerdo con la legislación colombiana el mismo ya fue consumido por parte del Usuario y no aplicaría sobre este rubro el derecho de retracto. El valor de la Firma Electrónica es de: COP$145.000 CIENTO CUARENTA Y CINCO MIL PESOS COLOMBIANOS al que pueden aplicar descuentos por pronto pago.",
  },
  {
    question: "5. ¿Por qué mi solicitud no fue aprobada?",
    answer:
      "En Galilea procesamos tu solicitud de manera automática gracias a la información que recolectamos en bases de datos externas, para darte una respuesta debemos analizar más de 400 variables lo que nos dificulta darte la razón exacta por la que hemos negado tu solicitud. Sin embargo, hemos dispuesto para ti información valiosa que te puede ayudar a que tu próximo intento sea exitoso.",
  },
  {
    question:
      "6. ¿Puedo realizar el pago antes de la fecha de vencimiento del crédito?",
    answer:
      "El Usuario está facultado y tiene derecho a efectuar pagos anticipados de las cuotas o saldos en forma total o parcial. En caso que el Usuario decida efectuar pagos anticipados totales o parciales deberá pagar los intereses y los cargos opcionales en proporción con el periodo de realización del pago.",
    answer2:
      "Los pagos anticipados que realice el Usuario serán abonados de la siguiente forma, salvo manifestación en contrario: ",
    lists: [
      { description: "Gastos de cobranza, si se han causado." },
      { description: "Intereses moratorios, si se han causado." },
      { description: "Firma Electrónica, si fue adquirida por el Usuario. " },
      { description: "Intereses corrientes." },
      { description: "Capital. " },
    ],
    finalanswer:
      "Galilea, no exigirá el pago de interés no causado, ni sanciones económicas por el pago anticipado de sus obligaciones.",
  },
  {
    question: "7. ¿Dónde puedo pagar mi crédito?",
    answer:
      "Para pagar tu crédito debes ingresar a tu cuenta y elegir alguno de nuestros canales físicos o electrónicos.",
  },
  {
    question:
      "8. ¿Cuáles son las consecuencias por el incumplimiento del pago del crédito en la fecha pactada?",
    answer:
      "Cuando no puedas pagar tu crédito en la fecha pactada te recomendamos comunicarte por medio de los canales de atención para llegar a un acuerdo de pago. En caso de no podernos contactar contigo o no evidenciemos voluntad de pago, recuerda que Galilea está facultada para realizar débitos automáticos a tu cuenta bancaria, generar gastos de cobranza de acuerdo a la gestión realizada, reportar ante centrales de riesgo tu información crediticia y ejecutar judicialmente el pagaré.",
  },
  {
    question:
      "9. ¿Cuánto tiempo permanece el reporte ante centrales de riesgo?",
    answer:
      "Ten en cuenta que, en las centrales de riesgo podrás contar con un reporte positivo o negativo, de acuerdo a tu comportamiento de pago. Por ello, de acuerdo a la Ley de Habeas Data la información de carácter positivo permanecerá de manera indefinida en los bancos de datos de los operadores de información. Pero, si presentaste mora de más de 30 días deberás asumir la permanencia del reporte negativo por el doble del tiempo que tu obligación se mantuvo en mora. Adicional, si la mora es igual o superior a 2 años el reporte negativo tendrá un plazo máximo de permanencia de 4 años, contados a partir de la fecha de pago o extinción de la obligación.",
  },
  {
    question: "10. ¿Qué son los gastos de cobranza?",
    answer:
      "El usuario reconocerá y pagará a favor de Galilea (acreedor), además de los intereses moratorios que se causen por la mora, los gastos de cobranza por incumplimiento del contrato de mutuo. Galilea dejará constancia de la acción de cobranza desplegada con el objetivo de liquidar los gastos de cobranza imputables al Usuario, así como los impuestos que deberá asumir.",
    answer2:
      "Galilea no aplica costos automáticos por el hecho de presentarse la mora, razón por la cual, el costo de gasto de cobranza es proporcional a las gestiones de cobro realizadas con el fin de cobrar los costos en que incurre Galilea o el acreedor para la realización de las gestiones de cobranza a través de empleados contratados para tal fin o firmas externas especializadas. ",
    answer3:
      "Esta gestión de cobro pre-jurídico por parte de Galilea comienza desde la fecha de vencimiento de la obligación y consiste en contactar e informar al Usuario acerca del estado de las obligaciones a través de diversos medios de contacto, tales como, pero sin limitarse a:  ",
    lists: [
      {
        description:
          "Llamadas telefónicas con contacto directo, sin contacto o mensajes a contestador automático.",
      },
      { description: "Envío de cartas a través de correo o telegramas." },
      { description: "Mensajería SMS." },
      { description: "Envío de correos electrónicos." },
      { description: "Notificadores." },
      { description: "Envío de mensajes a través de WhatsApp." },
    ],
    finalanswer:
      "Galilea conservará en medios verificables los soportes de la gestión de cobranza, así como los intentos de contacto o contactos. Todas las llamadas en el proceso de cobranza podrán ser grabadas y las mismas podrán ser conservadas junto con los registros que contengan la información de la persona que realiza el cobro, la fecha, hora y resumen de lo hablado, que podrá ser usadas como prueba de los compromisos adquiridos y de la calidad de las llamadas dentro de los estándares sugeridos por el regulador nacional. ",
  },
  {
    question: "11. ¿Cómo puedo obtener un acuerdo de pago?",
    answer:
      "Debes comunicarte por alguno de nuestros canales de atención y manifestar tu voluntad de pago, nuestro equipo de cartera buscará alternativas que te permitan ponerte al día.",
  },
  {
    question: "12. ¿Puedo tener más de un crédito vigente con Galilea?",
    answer:
      "No, si necesitas usar el total de tu cupo de crédito debes pagar primero las obligaciones financieras que tengas con nosotros, luego, solicitas nuevamente tu cupo de crédito mínimo desde $200.000.",
  },
  {
    question:
      "13. ¿Cuáles son las condiciones del contrato de crédito con Galilea?",
    answer:
      "Puedes encontrar el detalle de las condiciones descargando el borrador del contrato con Galilea el cual encuentras en el pie de página.",
  },
  {
    question:
      "14. ¿Cómo puedo firmar los documentos del crédito posterior a la aprobación del mismo?",
    answer:
      "El Usuario tiene la obligación previo al desembolso del crédito de firmar los documentos que lo vinculan legal y contractualmente con Galilea. El Usuario puede realizar la firma a través de medios electrónicos (Firma Electrónica) o de manera física incorporando en los documentos impresos su rúbrica, si el Usuario decide optar por la firma física, deberá notarizar todos los documentos del crédito, este proceso es informado más adelante.",
    answer2:
      "Una vez el Usuario realiza la firma de los documentos del crédito, Galilea procede a iniciar el trámite de desembolso del crédito, el cual de acuerdo a nuestra promesa de valor corresponde a menos de 1 día hábil posterior a la firma de los documentos del crédito. El desembolso puede verse afectado por razones externas a Galilea, correspondiente a la creación e inscripción de la cuenta bancaria, ciclos ACH o error en los datos proporcionados por el Usuario. El costo de la Firma Electrónica es opcional y podrás elegir asumir este servicio o describirlo y optar por el proceso de firma física, tal como se indica en la pregunta 16.",
  },
  {
    question:
      "15. ¿Cómo puedo firmar de manera electrónica mi contrato de crédito con Galilea?",
    answer:
      "Galilea pone a disposición del Usuario directamente o por intermedio de terceros la posibilidad de firmar los documentos del crédito a través de medios electrónicos. El procedimiento de firma electrónica consiste en la posibilidad de firmar los documentos de crédito posterior a la solicitud y aprobación del crédito. El procedimiento consiste en el envío de una Código One Time Password de 6 dígitos al número de celular y correo electrónico del Usuario, este procedimiento se encuentra reglamentado de conformidad con el Decreto 2364 de 2012, el artículo 7 de la Ley 527 de 199, y el artículo 244 del Código General del Proceso, normas que indican que los documentos en forma de mensaje de datos se presumen auténticos.",
    answer2:
      "Además, establecen que la firma electrónica se encuentra conformada por métodos tales como códigos, contraseñas, datos biométricos, o claves criptográficas privadas, que permiten identificar a una persona, en relación con un mensaje de datos. Lo anterior, siempre y cuando el mismo sea confiable y apropiado respecto de los fines para los que se utiliza la firma, atendidas todas las circunstancias del caso, así como cualquier acuerdo pertinente, en los términos de la norma citada.",
    answer3:
      "Recuerda que el cobro de la firma electrónica es opcional y no se causará en caso de que no desees usarla.",
  },
  {
    question:
      "16. ¿Cómo puedo realizar la firma de los documentos del crédito de manera física?",
    answer:
      "El Usuario de manera libre y voluntaria, de acuerdo a su libertad de escogencia contractual puede firmar de manera física los documentos del crédito. Razón por la cual, Galilea, ha dispuesto para el titular que no desee suscribir los documentos a través de la firma electrónica, un canal adicional para realizar la firma del crédito mediante el envío de la siguiente documentación a la dirección de correspondencia física Cl 79 No. 11 66 Ed Spaces o a la dirección electrónica ayuda@galilea.co, si los documentos son enviados a la dirección física o electrónica deben estar autenticados por notaria. Los documentos que debe enviar el Usuario son:",
    lists: [
      { description: "Fotocopia cédula de ciudadanía." },
      { description: "Certificado laboral no mayor a 30 días." },
      { description: "Últimos 3 desprendibles de pago de nómina." },
      { description: "Certificado de cuenta bancaria no mayor a 30 días." },
      {
        description:
          "Contrato de crédito debidamente firmado, la firma la debe incorporar en todas las páginas del documento.",
      },
      { description: "Pagaré y carta de instrucciones debidamente firmadas." },
      {
        description:
          "Documento de aceptación de los términos y condiciones generales del servicio debidamente firmado.",
      },
      {
        description:
          "Documento de aceptación de la Política de Privacidad y Tratamiento de datos debidamente firmado y autenticado ante Notaría.",
      },
    ],
    finalanswer:
      "El Usuario se obliga a suministrar información veraz, completa, actualizada y comprobable, así mismo, este deberá garantizar que a partir de los datos suministrados no busca inducir al error en los procesos internos, para lo cual, Galilea en procura de la veracidad realizará las rectificaciones respectivas siendo estas últimas de pleno conocimiento del Usuario. ",
  },
  {
    question: "17. ¿Cómo puedo solicitar la supresión de mis datos personales?",
    answer:
      "Podrás solicitar la supresión de tu información personal enviando solicitud a ayuda@galilea.co, con tus datos básicos como nombre, apellido, número de identificación. Ten en cuenta, que se procederá a realizar la supresión efectiva de tu información personal en el caso que no tengas obligaciones contraídas con Galilea, de lo contrario se mantendrá la permanencia de la información conforme lo establece la ley.",
  },
  {
    question: "18. ¿Cómo puedo proteger mis datos personales en la web?",
    answer:
      "No aceptes a personas desconocidas en redes sociales. Protege tus datos con las configuraciones de privacidad de las redes sociales. Conoce cuál será la finalidad del uso de tus datos personales cuando autorices su recolección y uso. Solicita la eliminación o exclusión de tu información una vez haya sido utilizada para el fin que fue solicitada. Brinda estrictamente la información necesaria cuando sea requerida. Lee con atención los términos y condiciones, los avisos de privacidad y/o las políticas en las que te explican cómo van a manejar tus datos personales. Conoce a quién entregas tus datos personales. Utiliza únicamente dispositivos electrónicos seguros para realizar transacciones financieras por internet.",
  },
  {
    question: "19. ¿Qué debo hacer si me acogí a la ley de insolvencia?",
    answer:
      "Deberás cumplir con el proceso dispuesto en la Ley de Insolvencia de Personal Natural 1564 de 2012. Una vez exista un acuerdo por Notaría, Centro de Conciliación o Sentencia Judicial, podrás enviarlo al correo ayuda@galilea.co.",
  },
  {
    question: "20. ¿Cuál es el canal autorizado para la radicación de PQRS?",
    answer:
      "Para radicar alguna, petición, queja, reclamo o solicitud, debes hacerlo enviando un correo con asunto 'pqrs' seguido de tu nombre y documento a ayuda@galilea.co.",
  },
  {
    question:
      "21. ¿Cuál es la entidad que ejerce vigilancia y control sobre la operación de Galilea?",
    answer:
      "La Superintendencia de industria y comercio es la encargada de ejercer control y vigilancia a las entidades comerciales como Galilea registrada en Colombia bajo la razón social GRUPO EMPRESARIAL ANAV S.A.S GEAA con NIT: 901.582.748-5.",
  },
  // More questions...
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function FaqsPage() {
  return (
    <div className="bg-purpleLight ">
      <Home
        title={"Información clara y precisa"}
        description={
          "En Galilea somos transparentes en la información que te brindamos y por eso hemos dispuesto para ti un lugar donde respondemos tus preguntas."
        }
      />
      <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto divide-y-2 divide-tdark">
          <h2 className="text-center tracking-tight text-3xl font-bold sm:text-4xl">
            Preguntas frecuentes
          </h2>
          <dl className="mt-6 space-y-6 divide-y divide-purple">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt className="text-xl">
                      <Disclosure.Button className="text-left w-full flex justify-between items-start">
                        <span className="font-bold">{faq.question}</span>
                        <span className="ml-6 h-7 flex text-purple items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "h-6 w-6",
                              "h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel
                      as="dd"
                      className="block mt-2 pr-12 text-lg"
                    >
                      <p className="pr-1 block w-full">{faq.answer}</p>
                      <p className="pt-4 pr-1 block w-full">{faq.answer2}</p>
                      <p className="pt-4 pr-1 block w-full">{faq.answer3}</p>
                      <div className="pt-4 pl-4">
                        {faq.lists?.map((list) => (
                          <ul
                            key={list.description}
                            role="list"
                            className="marker:text-purple list-disc"
                          >
                            <li> {list.description} </li>
                          </ul>
                        ))}
                      </div>

                      <p className="pt-4 pr-1 block w-full">
                        {faq.finalanswer}
                      </p>
                      <a
                        className={classNames(
                          faq.href ? "text-purple underline" : "hidden"
                        )}
                        href={faq.href}
                      >
                        Ver tarifas vigentes
                      </a>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
